import gql from 'graphql-tag';

const KB_ITEM_LIST_VIEW_META = gql`
  query {
    getKbItemListViewMeta
  }
`;

const KB_FEEDBACK_LIST_VIEW_META = gql`
  query {
    getKbArticleFeedbackListViewMeta
  }
`;

const GET_KB_ITEMS_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getKbItems(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
        hasMore
      }
      items {
        itemId
        name
        description
        status
        articleType
        createdBy {
          userId
          name
        }
        createdOn
        lastModifiedBy {
          userId
          name
        }
        parent {
          itemId
          itemType
          name
          parent {
            itemId
            name
          }
        }
        lastModifiedOn
        viewCount
        itemType
        visibilityType
      }
    }
  }
`;

const GET_COLLECTIONS = gql`
  query($listInfo: ListInfoInput!) {
    getKbItems(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
      items {
        itemId
        name
        description
        itemType
        loginRequired
        parent {
          itemId
          itemType
          name
        }
      }
    }
  }
`;

const GET_KB_ITEM = gql`
  query($input: KBItemIdentifierInput!) {
    getKbItem(input: $input) {
      itemId
      itemType
      name
      parent {
        itemId
        name
        parent {
          itemId
          name
        }
      }
      description
      status
      createdBy {
        userId
        name
      }
      createdOn
      loginRequired
      lastModifiedBy {
        userId
        name
      }
      lastModifiedOn
      contentUrl
      viewCount
      visibilityType
      articleType
      visibility {
        mappingId
        clientSharedType
        siteSharedType
        userRoleSharedType
        userSharedType
        groupSharedType
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        roles {
          roleId
          name
        }
        users {
          userId
          name
        }
        groups {
          groupId
          name
        }
        portalType
      }
    }
  }
`;

const GET_KB_ITEM_META = gql`
  query($input: KBItemIdentifierInput!) {
    getKbItem(input: $input) {
      itemId
      itemType
      name
      parent {
        itemId
        name
        parent {
          itemId
          name
        }
      }
    }
  }
`;

const GET_ARTICLE_FEEDBACK = gql`
  query($listInfo: ListInfoInput!) {
    getKbArticleFeedbacks(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        condition
        sort {
          attribute
          order
        }
      }
      articleFeedbacks {
        feedbackId
        feedback
        kbArticle {
          itemId
          name
        }
        status
        feedbackBy {
          userId
          name
        }
        createdOn
        resolvedBy {
          userId
          name
        }
        resolvedOn
      }
    }
  }
`;

// GraphQL query to search knowledge base articles by ticket ID and optional search term
const GET_KB_SEARCH = gql`
  query knowledgeBaseSearch($searchTerm: String!) {
    knowledgeBaseSearch(searchTerm: $searchTerm) {
      id
      subject
      description
      userType
      visibilityType
    }
  }
`;

const GENERATE_TICKET_DEFLECTION_SUGGESTIONS = gql`
  query generateTicketDeflectionSuggestions($userInput: String!) {
    generateTicketDeflectionSuggestions(userInput: $userInput)
  }
`;

const GENERATE_TICKET_DEFLECTION_SUGGESTIONS_V2 = gql`
  query generateTicketDeflectionSuggestionsV2(
    $subject: String!
    $description: String
  ) {
    generateTicketDeflectionSuggestionsV2(
      subject: $subject
      description: $description
    ) {
      aiGeneratedArticle {
        title
        content
      }
      citations {
        id
        title
      }
    }
  }
`;

const GET_KB_ARTICLE_FEEDBACKS = gql`
  query($listInfo: ListInfoInput!) {
    getKbArticleFeedbacks(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        condition
        sort {
          attribute
          order
        }
      }
      articleFeedbacks {
        feedbackId
        kbArticle {
          itemId
          name
          createdBy {
            userId
            name
          }
        }
        feedback
      }
    }
  }
`;

const KB_SUGGESTED_ARTICLE = gql`
  query getSuggestedKBArticles($ticketId: ID!, $searchTerm: String) {
    getSuggestedKBArticles(ticketId: $ticketId, searchTerm: $searchTerm) {
      articles {
        id
        subject
        description
        userType
        visibilityType
        loginRequired
      }
      searchTerm
    }
  }
`;

const GET_KB_REPLY_SUMMARY = gql`
  query getKBReplySummary($ticketId: ID!, $articleId: ID!) {
    getKBReplySummary(ticketId: $ticketId, articleId: $articleId)
  }
`;

// const GET_AI_KB_ARTICLE = gql`
//   query getAIKBArticle($ticketId: ID!) {
//     getAIKBArticle(ticketId: $ticketId) {
//       title
//       content
//     }
//   }
// `;

const GET_AI_KB_ARTICLE_V2 = gql`
  query getAIKBArticleV2($ticketId: ID!, $includeSimilarTickets: Boolean!) {
    getAIKBArticleV2(
      ticketId: $ticketId
      includeSimilarTickets: $includeSimilarTickets
    ) {
      title
      content
    }
  }
`;

const GET_AI_KB_MISSING_INFO = gql`
  query getAIKBMissingInfo(
    $ticketId: ID!
    $kbArticle: AIGeneratedArticleInput!
  ) {
    getAIKBMissingInfo(ticketId: $ticketId, kbArticle: $kbArticle) {
      ticketId
      missingInfo
      displayId
    }
  }
`;

const GET_UPDATED_AI_KB_ARTICLE = gql`
  query getUpdatedAIKBArticle(
    $kbArticle: AIGeneratedArticleInput!
    $missingInfos: [AIKBMissingInfoInput]
  ) {
    getUpdatedAIKBArticle(kbArticle: $kbArticle, missingInfos: $missingInfos) {
      title
      content
    }
  }
`;

export {
  KB_ITEM_LIST_VIEW_META,
  KB_FEEDBACK_LIST_VIEW_META,
  GET_KB_ARTICLE_FEEDBACKS,
  GET_KB_ITEMS_LIST,
  GET_KB_ITEM,
  GET_KB_ITEM_META,
  GET_ARTICLE_FEEDBACK,
  GENERATE_TICKET_DEFLECTION_SUGGESTIONS,
  GENERATE_TICKET_DEFLECTION_SUGGESTIONS_V2,
  GET_COLLECTIONS,
  // GET_AI_KB_ARTICLE,
  GET_AI_KB_ARTICLE_V2,
  GET_AI_KB_MISSING_INFO,
  GET_UPDATED_AI_KB_ARTICLE,
  KB_SUGGESTED_ARTICLE,
  GET_KB_REPLY_SUMMARY,
  GET_KB_SEARCH
};
